import { get } from 'lodash-es';

/**
 * Creates a valueFormatter for time values with timezone display
 *
 * @param timezoneField - The field path to get the timezone from (e.g., 'Attrs.SalesforceAttrs.ProdMaintenanceTimezone')
 * @returns A valueFormatter function that can be used in column definitions
 *
 * @example
 * ```typescript
 * const column = {
 *   type: 'custom',
 *   field: 'Attrs.SalesforceAttrs.ProdMaintenanceStartsAt',
 *   title: 'Prod Maintenance Start',
 *   params: {
 *     valueFormatter: timeWithTimezoneFormatter('Attrs.SalesforceAttrs.ProdMaintenanceTimezone'),
 *   },
 * };
 * ```
 */
export function timeWithTimezoneFormatter(timezoneField: string) {
  return ({ value, data }: { value: string | undefined; data: unknown }) => {
    if (!value || typeof value !== 'string') {
      return '';
    }
    const timezone = get(data, timezoneField) || '';
    const timeOnly = value.split('.')[0]; // Remove milliseconds
    return `${timeOnly} ${timezone}`;
  };
}
